"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _form_styles = _interopRequireDefault(require("./form_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils
// styles

/* ========== ~~~~~~~~~~ EXPORT : FORM ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_form_styles.default)(function (props) {
  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault(); // prevent initial submission of form
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (props.handleKeyDown) props.handleKeyDown(e);
  };

  return _react.default.createElement("form", {
    className: "form ".concat((0, _index.generateClasses)(props), " ").concat(props.classes.form, " processing-").concat(props.processing, " editable-").concat(props.editable),
    name: props.name,
    onKeyDown: handleKeyDown,
    onSubmit: handleFormSubmit
  }, props.children);
});

exports.default = _default;